/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const ConversationsIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M16.6203 12.7754C17.4795 11.8846 17.9949 10.767 17.9949 9.54759C17.9949 6.91805 15.605 4.74539 12.4903 4.35753C11.5093 2.46426 9.19439 1.13306 6.4983 1.13306C2.90873 1.13306 0.000210412 3.4865 0.000210412 6.39214C0.000210412 7.6083 0.515684 8.72586 1.37481 9.6199C0.896822 10.629 0.209524 11.4113 0.197028 11.4244C0.000210417 11.6447 -0.0560231 11.9668 0.059568 12.2462C0.172035 12.5255 0.434458 12.7063 0.721874 12.7063C2.39326 12.7063 3.74286 12.0424 4.63323 11.431C4.91752 11.5 5.20806 11.5526 5.50797 11.5888C6.49205 13.4788 8.80388 14.81 11.5 14.81C12.1498 14.81 12.7746 14.7311 13.3682 14.5865C14.2585 15.1945 15.605 15.8618 17.2795 15.8618C17.5669 15.8618 17.8262 15.681 17.9418 15.4016C18.0543 15.1222 18.0012 14.8001 17.8044 14.5799C17.7887 14.5667 17.0983 13.7844 16.6203 12.7754ZM4.44266 10.3036L4.08651 10.5468C3.45857 10.9774 2.50885 11.4737 1.34669 11.6151C1.62161 11.2436 1.97775 10.7079 2.26829 10.0899L2.5932 9.40625L2.07773 8.87048C1.58412 8.36101 0.999917 7.51627 0.999917 6.39214C0.999917 4.07157 3.46794 2.18487 6.4983 2.18487C9.52866 2.18487 11.9967 4.07157 11.9967 6.39214C11.9967 8.71271 9.52866 10.5994 6.4983 10.5994C5.94534 10.5994 5.39238 10.5337 4.85503 10.4022L4.44266 10.3036ZM13.9086 13.7023L13.5525 13.459L13.1401 13.5609C12.6028 13.6924 12.0498 13.7581 11.4968 13.7581C9.46306 13.7581 7.68545 12.9068 6.73573 11.6447C10.2128 11.5395 12.9964 9.23205 12.9964 6.39214C12.9964 6.07988 12.9558 5.77749 12.8933 5.48166C15.2489 5.95827 16.9952 7.59844 16.9952 9.54759C16.9952 10.6717 16.411 11.5165 15.9174 12.0259L15.4019 12.5617L15.7237 13.2421C16.0174 13.8633 16.3735 14.3991 16.6453 14.7672C15.4863 14.6292 14.5366 14.1296 13.9086 13.7023ZM12.7277 4.90316C12.7308 4.90974 12.7308 4.91631 12.734 4.92288C12.7308 4.91631 12.7308 4.90974 12.7277 4.90316Z"
        fill={color}
      />
    </svg>
  );
};
